import { render, staticRenderFns } from "./ConsultButton.vue?vue&type=template&id=60a54d8c&scoped=true&"
import script from "./ConsultButton.vue?vue&type=script&lang=ts&"
export * from "./ConsultButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultButton.vue?vue&type=style&index=0&id=60a54d8c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a54d8c",
  null
  
)

export default component.exports